export const JEPA_FOLDER = {
    TAX: 'Impôts sur les revenus',
    SCI: 'Impôt SCI',
    LMNP: 'Impôt LMNP'
}